<div class="container">
	@if (label && selectedTime) {
		<div class="container__label">
			<span>{{ label | translate }}</span>
		</div>
	}
	<div
		class="container__input-wrapper"
		[class]="{
			'container__input-wrapper--disabled': isDisabled,
			'container__input-wrapper--required': isRequired && !selectedTime && ngControl?.control?.touched
		}"
	>
		<input
			class="container__input"
			[disabled]="isDisabled"
			[value]="selectedTime"
			[placeholder]="isRequired ? (placeholder() | translate) + '*' : (placeholder() | translate)"
			(change)="onValueChange($event)"
			(input)="onInputChange($event)"
			(focus)="setTouchState(true)"
			tabindex="{{ isDisabled ? -1 : 0 }}"
			[class]="{
				'container__input--disabled-with-value': selectedTime && isDisabled,
				'container__input--disabled': isDisabled && !selectedTime
			}"
		/>
		<input matInput [hidden]="true" [format]="HOURS_FORMAT" [ngxTimepicker]="picker" />
		<ngx-material-timepicker-toggle
			[disabled]="isDisabled"
			(click)="setTouchState(true)"
			(focus)="setTouchState(true)"
			[for]="picker"
			class="form__timepicker"
		>
			<mat-icon class="container__icon" svgIcon="time_picker"></mat-icon>
		</ngx-material-timepicker-toggle>
		<ngx-material-timepicker
			dir="ltr"
			#picker
			[format]="HOURS_FORMAT"
			[confirmBtnTmpl]="confirmBtn"
			[cancelBtnTmpl]="cancelBtn"
			[theme]="lawyalTheme"
			[defaultTime]="selectedTime"
			(timeSet)="setSelectedTime($event)"
		>
		</ngx-material-timepicker>
	</div>
	@if (errorType || hint) {
		<div class="container__text-wrapper">
			@if (errorType) {
				<span class="container__text container__text--error">{{ errorType | translate }}</span>
			}
			@if (!errorType && hint) {
				<span class="container__text container__text--hint">{{ hint | translate }}</span>
			}
		</div>
	}
	<!--  <div class="container__hint" *ngIf="hint" [@fadeInOut]>{{ hint | translate }}</div>-->
</div>

<ng-template #cancelBtn>
	<submit-button [title]="'MODALS.NEW_REPORT_MODAL.CANCEL' | translate"> </submit-button>
</ng-template>

<ng-template #confirmBtn>
	<submit-button [filled]="true" [title]="'MODALS.NEW_REPORT_MODAL.SAVE' | translate"> </submit-button>
</ng-template>
